var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[_c('CommonExpansionPanel',{scopedSlots:_vm._u([{key:"title-panel",fn:function(){return [_vm._v(" Historial de modificaciones ")]},proxy:true}])},[_c('ViewPolizaLogCard',{attrs:{"polizaInfo":_vm.polizaInfo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }